/**
 * Database Explorer — write/DDL audit changelog contracts.
 *
 * `changelog.list` reads db_explorer_changelog newest-first. `exportSql`
 * returns the successful write/DDL statements in order as text/plain via the
 * Response escape hatch — the migration-drift escape hatch (PRD §3, §13).
 */

import { z } from "zod";
import type { Operation } from "../../types";

export const changelogRowSchema = z.object({
  id: z.number(),
  workspace_id: z.number(),
  source: z.string(),
  kind: z.string(),
  sql: z.string(),
  changes: z.number().nullable(),
  ok: z.number(),
  error: z.string().nullable(),
  actor_id: z.number().nullable(),
  agent_id: z.string().nullable(),
  model: z.string().nullable(),
  prompt: z.string().nullable(),
  created_at: z.string(),
});
export type ChangelogRowDto = z.infer<typeof changelogRowSchema>;

export const changelogListQuery = z.object({
  limit: z.coerce.number().int().min(1).max(1000).optional(),
});

export const changelogList: Operation<
  void,
  z.infer<typeof changelogListQuery>,
  void,
  z.infer<typeof changelogRowSchema>[]
> = {
  method: "GET",
  path: () => "/api/database/changelog",
  query: changelogListQuery,
  response: z.array(changelogRowSchema),
};

// Response is text/plain via the escape hatch — the handler returns a raw
// `Response`, so TResult is `unknown` (the client downloads the body through
// an <a download> using `op.path()`, it never parses an envelope).
export const changelogExportSql: Operation<void, void, void, unknown> = {
  method: "GET",
  path: () => "/api/database/changelog/export",
  response: z.unknown(),
};

export const changelog = {
  list: changelogList,
  exportSql: changelogExportSql,
};
